import { API_TYPES } from "@src/appV2/api";
import { z } from "zod";

export const facilityUserInternalNotesSchema = z.object({
  id: z.string(),
  attributes: z.object({
    workplaceId: z.string(),
    facilityUserId: z.string(),
    notes: z.string(),
  }),
  type: z.literal(API_TYPES.facilityUserInternalNotes),
});
export type FacilityUserInternalNotes = z.infer<typeof facilityUserInternalNotesSchema>;

export const facilityUserInternalNotesResponseSchema = z.object({
  data: facilityUserInternalNotesSchema,
});
export type FacilityUserInternalNotesResponse = z.infer<
  typeof facilityUserInternalNotesResponseSchema
>;

export const updateFacilityUserInternalNotesRequestSchema = z.object({
  data: z.object({
    id: z.string(),
    type: facilityUserInternalNotesSchema.shape.type,
    attributes: facilityUserInternalNotesSchema.shape.attributes.pick({ notes: true }),
  }),
});
export type UpdateFacilityUserInternalNotesRequest = z.infer<
  typeof updateFacilityUserInternalNotesRequestSchema
>;
